import React from "react"
import styled from "styled-components"
import media from "styled-media-query"
import Progress from "../organisms/progress"
import Image from "../atoms/image"
import { BackButton } from "../atoms/button"
import Awards from "../organisms/awards"
import RComment from "../molecules/r-comment"
import MediaQuery from "react-responsive"

const Wrap = styled.div`
  ${media.greaterThan("small")`
    display: flex;
  `}
`
const ImageWrap = styled.div`
  height: 100%;
  width: 100%;
  margin: 13px 0 8px 0;
  ${media.greaterThan("small")`
    height: 382px;
    margin: 45px 0 0 0;
  `}
`
const LeftWrap = styled.div`
  ${media.greaterThan("small")`
    display: flex;
    width: 52%;
  `}
`
const RightWrap = styled.div`
  ${media.greaterThan("small")`
    flex:1;
    padding: 38px 0 0 30px;
  `}
`

const ResultTemplate = props => {
  const index = props.index
  const resultList = props.resultList
  const award = props.award
  const imageNameSP = props.imageNameSP
  const imageNamePC = props.imageNamePC
  const toIndex = props.toIndex
  const hText: string = props.hText
  const hComment: string = props.hComment
  const comment: string = props.comment
  return (
    <>
      <Progress index={index} resultList={resultList} />
      <Awards index={index} hText={hText} awardImage={award} />
      <Wrap>
        <LeftWrap>
          <ImageWrap>
            <MediaQuery query="(max-width: 449px)">
              <Image name={imageNameSP} />
            </MediaQuery>
            <MediaQuery query="(min-width: 450px)">
              <Image name={imageNamePC} />
            </MediaQuery>
          </ImageWrap>
        </LeftWrap>
        <RightWrap>
          <RComment hComment={hComment} comment={comment} />
          <BackButton onClick={toIndex}>トップに戻る</BackButton>
        </RightWrap>
      </Wrap>
    </>
  )
}

export default ResultTemplate
